import Schema from 'async-validator';
import basicMixin from '../../../assets/mixins/basic';

export default {
  mixins: [basicMixin],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      /** 校验器 */
      validator: null,
      /** 焦点 */
      isFoucs: false,
      /** 手机号 */
      mobile: '',
      /** 错误msg */
      errors: []
    };
  },

  mounted() {
    this.validator = new Schema(this.formDescriptor);
    window.addEventListener('click', this.handleBlur);
  },

  beforeDestroy() {
    this.validator = null;
    window.removeEventListener('click', this.handleBlur);
  },

  computed: {
    formDescriptor() {
      return {
        mobile: [
          { type: 'string', required: true, message: this.iarTrans('order.noMobileMsg') },
          { pattern: /^1[3-9]\d{9}$/, message: this.iarTrans('order.mobileFormatError') }
        ]
      };
    },
  },

  watch: {
    mobile(value) {
      this.$emit('change', value);
    }
  },

  methods: {
    /**
     * @description: 聚焦
     * @return {void}
     */
    handleFoucs() {
      this.errors = [];
      this.isFoucs = true;
      this.$emit('phone-input-focus');
    },
    handleInputBlur() {
      this.$emit('phone-input-blur');
    },
    /**
     * @description: 失焦
     * @return {void}
     */
    handleBlur(event) {
      if (!this.isFoucs) return;
      if (this.$refs.mobileInput.contains(event.target) || this.$refs.clearButton.contains(event.target)) {
        return;
      }
      this.validateField();
      this.isFoucs = false;
    },
    /**
     * @description: 清空
     * @return {void}
     */
    handleClear() {
      this.mobile = '';
      this.$refs.mobileInput.focus();
    },
    /**
     * @description: 检验表单项
     * @return {Promise<Object>}
     */
    async validateField() {
      return new Promise((resolve, reject) => {
        const data = { mobile: this.mobile };
        this.validator.validate(data, (errors, fields) => {
          if (errors) {
            this.errors = [...errors];
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ errors, fields });
          } else {
            resolve(data);
          }
        });
      });
    }
  }
};
